import { DtoRequestCostsacctsPostReq } from "./abst/DtoRequestCostsacctsPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestCostsacctsPostReqImple extends DtoRequestCostsacctsPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
